import * as Yup from 'yup';

export default Yup.object().shape({
  equipmentId: Yup.number().required('SCHEMA_ERRORS.SELECT_VALUE'),
  clientId: Yup.number().required('SCHEMA_ERRORS.SELECT_VALUE')
});
